export interface FolderLocationInfo {
  locationID: number;
  locationName: string;
  assetCount: number;
}

export interface ScheduleSelection {
  workDaysScheduleID: number;
  daysOffScheduleID: number;
}

export interface MultiLocationScheduleConfig {
  mode: 'per-location';
  global: ScheduleSelection;
  locations: { [locationID: string]: ScheduleSelection };
  workDaysScheduleID?: number;
  daysOffScheduleID?: number;
}

export interface CalendarPreviewResult {
  workingDays: string[];
  daysOff: string[];
  dayDetails: { [date: string]: CalendarDayDetail };
}

export interface CalendarDayDetail {
  status: 'working' | 'off' | 'unscheduled';
  reason?: string;
  entries?: any[];
}

export interface WorkScheduleEntry {
  createdAt: number;
  creator: number;
  dayOfWeek?: number;
  effectiveDate?: string;
  endDate?: string;
  endTime?: string;
  entryID: number;
  expiresDate?: string;
  isInherited?: boolean;
  lastUpdate?: number;
  notes?: string;
  relativeDayName?: string;
  relativeDayOffset?: number;
  repeatAnnually?: number;
  scheduleID: number;
  startDate?: string;
  startTime?: string;
  subjectID?: number;
  subjectType?: string;
  daysOfWeek?: number[];
  excluded?: boolean;
}

export enum WorkScheduleEntryType {
  Day_Of_Week = 'day_of_week',
  Specific_Date = 'specific_date',
  Relative_Date = 'relative_date'
}

export interface WorkSchedule {
  attributes?: {
    access?: 'shared' | 'private';
  };
  createdAt: number;
  creator: number;
  disabledAt: number;
  disabledBy: number;
  entries: WorkScheduleEntry[];
  isDefault: number;
  lastUpdate: number;
  locationID: number;
  name: string;
  parentScheduleID: number;
  scheduleID: number;
  subjectID: number;
  subjectType: string;
  type: WorkScheduleType;
}

export enum WorkScheduleType {
  Work_Days = 'work_days',
  Days_Off = 'days_off'
}
